import axios from '../../axios/index.js'

export default {
    getOptions (type) {
      return axios.get(`/salary_analysis/select/positions/${type}`)
    },
    getTable (data) {
        return axios.get('/salary_analysis/datatable',{ params: data })
    },
  }